// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + ".chunk.js");